import React from 'react';
import { Sidebar } from './components/Sidebar';
import { Header } from './components/Header';
import { StatsCards } from './components/StatsCards';
import { CampaignList } from './components/CampaignList';
import { FloatingCart } from './components/billing/FloatingCart';
export function App() {
  return <div className="flex w-full min-h-screen bg-white" data-id="element-0">
      <Sidebar data-id="element-1" />
      <main className="flex-1" data-id="element-2">
        <Header data-id="element-3" />
        <div className="px-6 py-4" data-id="element-4">
          <h2 className="text-2xl font-medium text-gray-800 mb-6" data-id="element-5">
            All Campaigns
          </h2>
          <StatsCards data-id="element-6" />
          <CampaignList data-id="element-7" />
        </div>
      </main>

      {/* Floating Cart */}
      <FloatingCart data-id="element-8" />
    </div>;
}